import {PageComponentTypeEnum} from "../Enums/PageComponentTypeEnum";

export interface PageComponentInterface {
	title: string,
	show_title: boolean,
	type: string,
	data: any,
}

export class PageComponentClass implements PageComponentInterface {
	title = '';
	show_title = true;
	type = PageComponentTypeEnum.CAROUSEL;
	data = [];
}
